import { get2 } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { KioskSettings } from "@/shared/utils/interfaces";
import { useQuery } from "@tanstack/react-query";

const useKioskSettingsQuery = () => {
  const branchId = useBranchId();

  const query = useQuery<KioskSettings>({
    queryKey: ["kiosk-settings", branchId],
    queryFn: () =>
      get2(`/internal/secure/pos/v1/kiosk-settings/${branchId}`),
    enabled: branchId !== -1,
  });

  return query;
};

export default useKioskSettingsQuery;
